import { client } from './client';

export const validateEmail = (emailAddress = '') =>
  client('emailverification', {
    method: 'GET',
    params: {
      emailAddress
    }
  });
